// assets/es-menu-popover.js
// New 2026-07-27 (Jeff): replaces the mobile hamburger's full category mega-menu drawer with a
// small, simple popover -- just Home / Products / Contact / Order Tracking, plus Account (moved
// here since the account icon is now hidden on mobile, per theme.liquid's ".block-user { display:
// none }" mobile rule). Deliberately the same visual component as assets/es-vehicle-popover.js
// (same card styling, same open/position/close-on-outside-click behavior) since Jeff wants the
// two buttons and their popovers to feel like one consistent pattern, not two different widgets.
(function () {
  var POPOVER_ID = 'es-menu-popover';

  var LINKS = [
    { label: 'Home', href: '/' },
    { label: 'Products', href: '/collections/all' },
    { label: 'Contact', href: '/pages/contact' },
    { label: 'Order Tracking', href: 'https://eurospeed.co/tools/tracking' },
    { label: 'Account', href: '/account' }
  ];

  function ensureStyle() {
    if (document.getElementById(POPOVER_ID + '-style')) return;
    var style = document.createElement('style');
    style.id = POPOVER_ID + '-style';
    style.textContent =
      '#' + POPOVER_ID + ' { position: fixed; z-index: 1000; display: none; }' +
      '#' + POPOVER_ID + '.es-vp--open { display: block; }' +
      '#' + POPOVER_ID + ' .es-vp-card {' +
        'width: 220px; max-width: calc(100vw - 24px); background: #fff; border: 1px solid #dedede;' +
        'border-radius: 14px; box-shadow: 0 16px 40px rgba(17,24,39,.16); padding: 10px; }' +
      '#' + POPOVER_ID + ' a {' +
        'display: block; padding: 11px 14px; border-radius: 9px; font-size: 14px; font-weight: 600;' +
        'color: #1f1f1f; text-decoration: none; }' +
      '#' + POPOVER_ID + ' a:hover { background: #f4f5f7; color: var(--engoc-primary-color, #10a8ee); }' +
      '#' + POPOVER_ID + ' a + a { margin-top: 2px; }';
    document.head.appendChild(style);
  }

  function build() {
    var existing = document.getElementById(POPOVER_ID);
    if (existing) return existing;
    ensureStyle();
    var wrap = document.createElement('div');
    wrap.id = POPOVER_ID;
    var card = document.createElement('div');
    card.className = 'es-vp-card';
    LINKS.forEach(function (link) {
      var a = document.createElement('a');
      a.href = link.href;
      a.textContent = link.label;
      card.appendChild(a);
    });
    wrap.appendChild(card);
    document.body.appendChild(wrap);
    return wrap;
  }

  function positionUnder(anchorEl, wrap) {
    var rect = anchorEl.getBoundingClientRect();
    var cardWidth = Math.min(220, window.innerWidth - 24);
    var left = rect.left;
    left = Math.max(12, Math.min(left, window.innerWidth - cardWidth - 12));
    wrap.style.top = (rect.bottom + 10) + 'px';
    wrap.style.left = left + 'px';
  }

  function close() {
    var wrap = document.getElementById(POPOVER_ID);
    if (wrap) wrap.classList.remove('es-vp--open');
    document.removeEventListener('click', onOutsideClick, true);
  }

  function onOutsideClick(e) {
    var wrap = document.getElementById(POPOVER_ID);
    if (!wrap || wrap.contains(e.target)) return;
    close();
  }

  function open(anchorEl) {
    var wrap = build();
    positionUnder(anchorEl, wrap);
    wrap.classList.add('es-vp--open');
    document.addEventListener('click', onOutsideClick, true);
  }

  window.ESMenuPopover = {
    toggle: function (anchorEl) {
      var wrap = document.getElementById(POPOVER_ID);
      if (wrap && wrap.classList.contains('es-vp--open')) { close(); return; }
      open(anchorEl);
    },
    close: close
  };

  window.addEventListener('resize', function () {
    var wrap = document.getElementById(POPOVER_ID);
    if (wrap && wrap.classList.contains('es-vp--open')) close();
  });

  function bindButton() {
    var btn = document.getElementById('es-header-menu-select');
    if (!btn || btn.__esMpBound) return;
    btn.__esMpBound = true;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.ESMenuPopover.toggle(btn);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindButton);
  } else {
    bindButton();
  }
})();
